/* This example requires Tailwind CSS v2.0+ */
import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { Button } from '../../common';

const NavbarPrimaryDesktopCtaButton = (props) => {
  const { sanity } = props;
  const { navbars } = sanity;

  const variants = {
    initial: { opacity: 0.1, scale: 0.8 },
    animate: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        delay: 0,
      },
    },
  };

  return (
    <motion.div
      className="absolute inset-y-0 right-0 hidden items-center pr-2 sm:static sm:inset-auto sm:pr-0 lg:flex"
      variants={variants}
      initial="initial"
      animate="animate"
    >
      <div className="hidden sm:flex sm:items-center">
        <Button
          linkType="internal"
          internalLink={navbars?.navCtaButtonLink?.slug?.current}
          label={navbars?.navCtaButtonLabel}
          sanity={sanity}
        />
      </div>
    </motion.div>
  );
};

export { NavbarPrimaryDesktopCtaButton };
